
// Filename - pages/about.js
 
import React from "react";
import styles from './about.module.css';
const About = () => {
    return (
        <div>
            <h1 className={styles.h1}>
                Yehia Eltantawi
            </h1>
        </div>
    );
};
 
export default About;